import { render } from "./LocatorList.vue?vue&type=template&id=0f59ddb8&scoped=true&ts=true"
import script from "./LocatorList.vue?vue&type=script&lang=ts"
export * from "./LocatorList.vue?vue&type=script&lang=ts"

import "./LocatorList.vue?vue&type=style&index=0&id=0f59ddb8&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f59ddb8"]])

export default __exports__